export default {
	'livecourse': {
		'text': `<h3 class="content-heading">Barbara Minto holds an MBA from Harvard Business School. She personally conducts a world-renowned 2-day course for professional
        people in how to use the Minto Pyramid Principle to shorten the time you spend writing.</h3>
      <div class="content-caption-box">
        <h3 class="content-caption">The Course</h3>
      </div>
      <p class="content-text">Organized for groups of 10-14 within a single company, the course shows how to use the pyramid rules to discover and clarify
        the points you want to make. And it explains the value of the unique Situation-Complication-Question framework (SCQ Framework
        tm) to identify the question your document is being written to answer. She also offers a shortened, 1-day version of
        the basics as a refresher for people who already have some knowledge of the Minto Pyramid Principle.</p>
      <div class="content-caption-box">
        <h3 class="content-caption">The Content</h3>
      </div>
      <p class="content-text">The 2-day course is structured around the work of the people in the group. To this end, Barbara asks each person attending
        to send her in advance a lengthy sample of his work. She then reads these, draws pictures of their structures, develops
        new structures, and uses them as examples in the course.</p>
      <p class="content-text">Both the 2-day and 1-day courses include an individual tutoring session with Barbara at the end of the formal sessions.
        She meets personally with each person for 45-minutes to help him apply the pyramid-building process to something he is
        about to write. It is this tutoring session that makes the technique "take". </p>
      <p class="content-text">Barbara’s courses are based on a similar course she developed and taught for several years at McKinsey & Company, Inc.,
        the international management consulting firm. In addition to teaching McKinsey’s consultants and many of its clients,
        as well as all of the other major consulting firms, she has lectured at the Harvard, MIT, Stanford, Chicago, London and
        Manchester business schools, and at the State University of New York.</p>
      <p class="content-text">To find out more about Barbara’s courses, e-mail inquiries@barbaraminto.com</p>

      <img src="/assets/images/livecourse-img.png" alt="" class="content-img">`
	}
}


// WEBPACK FOOTER //
// ./client/app/modules/site/livecourse/i18n/es.js